import Router from "@src/lib/router";
import { store } from "@root/store";
import {
  closeAllBottomSheetsAction,
  showFreeTrialBottomSheetAction,
  showRunningTightOnBudgetBottomSheetAction,
} from "../../components/BottomSheets/store/actions";
import { COURSE_TABS_ENUMS } from "../constants";
import { installmentsAlertStateEnum } from "@src/components/Tabs/Overview/store/constants.js";
import { hitHapticFeedback } from "..";
import { newWebEngage } from "@src/utils/webEngageEvent";
// SHOW PROMPT
const prompt = () => {
  // alertstore?.getState()?.bottomSheetReducer?.isShowDueDateBottomSheet);
  if (
    !store?.getState()?.bottomSheetReducer?.showBottomStatesOnce
      ?.isShowRunningTightOnBudgetBottomSheet
  ) {
    store.dispatch(showRunningTightOnBudgetBottomSheetAction(true));
  }
};

// CLOSE WEBVIEW EVENT
const quitWebview = () => {
  // STATES
  const alertState =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.installments
      ?.installmentAlert?.alertState;
      
  const tabList = store?.getState()?.tabBarReducer?.tabList || [];
  const trialTabData = tabList.find((tab) => tab.enumKey === COURSE_TABS_ENUMS.TRIAL_CONTENT);
  if(trialTabData && trialTabData.isLocked) {
    store.dispatch(showFreeTrialBottomSheetAction(true));
  } else if (
    alertState === installmentsAlertStateEnum.TIGHT_BUDGET &&
    !store?.getState()?.bottomSheetReducer?.showBottomStatesOnce
      ?.isShowRunningTightOnBudgetBottomSheet
  ) {
    prompt();
  } else {
    quitWebviewDeeplink();
  }
};

export const checkCourseStatus = () => {
  const state = store?.getState()?.overviewReducer?.overViewDetails?.course;

  if (state?.metaData?.isPurchased) return "PURCHASED";
  // TODO NATIVE EVENT NAME
  else {
    if (state?.installments?.paidInstallmentSummary?.isPaymentComplete == 0)
      return "INSTALLMENT PENDING";
    return "NEW";
  }
};

export const quitWebviewDeeplink = () => {
  const courseState =
    store?.getState()?.overviewReducer?.overViewDetails?.course;
  const graphState = store?.getState()?.overviewReducer?.graphCourseData;
  const graphCouponState =
    store?.getState()?.overviewReducer?.graphCourseCouponListData;

  // newWebEngage("course_overview_back_press", {
  //   // courseid: `${router?.query?.courseId}`,
  //   course_name: `${courseState?.details?.name}`,
  //   course_price: courseState?.priceDetails?.coursePrice,
  //   course_status: `${checkCourseStatus()}`,
  //   final_amount: graphState?.priceBottom?.val / 100,
  //   has_coupon: `${graphCouponState?.totalCount > 0}`,
  //   has_viewed: `${courseState?.metaData?.hasViewed || 0}`,
  //   action: "Overview Back Press",
  // });
  window?.mobile?.performAction?.(`ACTION_CLOSE`, null);
  window?.webkit?.messageHandlers?.stateEvents?.postMessage("QUIT");
};
const handleBackEvent = (paramEvent) => {
  const courseState =
    store?.getState()?.overviewReducer?.overViewDetails?.course;
  const graphState = store?.getState()?.overviewReducer?.graphCourseData;
  const graphCouponState =
    store?.getState()?.overviewReducer?.graphCourseCouponListData;

  newWebEngage("course_overview_back_press", {
    // courseid: `${router?.query?.courseId}`,
    course_name: `${courseState?.details?.name}`,
    course_price: courseState?.priceDetails?.coursePrice,
    course_status: `${checkCourseStatus()}`,
    final_amount: graphState?.priceBottom?.val / 100,
    has_coupon: Boolean(`${graphCouponState?.totalCount > 0}`),
    has_viewed: Boolean(`${courseState?.metaData?.hasViewed || 0}`),
    action: "Overview Back Press",
  });
  hitHapticFeedback();
  // TODO BETTER SOLUTION FOR LANDING ON RANDOM PAGE
  // STATES
  if (
    Router.router.route !== "/[courseId]/[tabId]" &&
    Router.router.query.token
  ) {
    Router.push(`/${Router.query.courseId}/1`);
  }

  const baseTab = store
    ?.getState()
    ?.tabBarReducer?.tabList?.find?.(
      (tab) => tab?.enumKey === COURSE_TABS_ENUMS?.OVERVIEW
    )?.id;
  const bottomSheetReducer = store?.getState()?.bottomSheetReducer;

  if (
    Object.keys(bottomSheetReducer).some(
      (i) => bottomSheetReducer[i] && typeof bottomSheetReducer[i] !== "object"
    )
  ) {
    // console.log(bottomSheetReducer);
    store?.dispatch(closeAllBottomSheetsAction());
    return;
  } else if (paramEvent) {
    paramEvent();
  } else if (Router?.query?.tabId) {
    if (Router?.query?.tabId === `${baseTab}`) {
      quitWebview();
    } else {
      Router?.push(`/${Router?.query?.courseId}/${baseTab}`);
    }
  } else if (
    Router.router.route !== "/[courseId]/[tabId]" &&
    Router.router.query.token
  ) {
    Router.push(`/${Router.query.courseId}/1`);
  } else {
    Router.back();
  }
};

export default handleBackEvent;
